import { PartsStore, Query, QueryGetPartsStoresArgs } from "../generated/nest-graphql";
import { useQuery } from "@apollo/client";
import { defaultTo } from "ramda";
import { GET_PARTS_STORES } from "../graphql/queries/getPartsStores";

export const usePartsStores = (): PartsStore[] => {
  const { data } = useQuery<Query, QueryGetPartsStoresArgs>(GET_PARTS_STORES, {});
  return defaultTo([])(data?.getPartsStores);
};
